import {Checkbox, makeStyles, Tooltip, withStyles} from '@material-ui/core';
import clsx from 'clsx';
import {useDispatch} from 'react-redux';
import UtilService from '../../../helper/service';
import {useHistory} from "react-router";
import {
  getSessionParticipantsSuccess,
  initLiveAnalysisData
} from '../../../store/actions/creator/creatorExperienceManager';
import {getStimulusAnalysis, initAnalysisData} from "../../../store/actions/creator/analysis";
import roles from "../../../helper/roles";
import DotMenuListing from "../creator/dashboardDotMenuListing";
import {apiClient} from "../../../config/apiClient";
import {useCallback} from "react";
import useWindowSize from '../../../helper/hooks/useWindowSize';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#697683',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const useStyles = makeStyles(() => ({
  creatorDashboardCircle : {
    height:"41px",
    width:"41px",
    fontWeight:"bold",
    paddingTop: "0",
    paddingLeft: "0",
    borderRadius: '50%',
    fontSize: '14px',
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
  },
  creatorDashboardCircleUsername : {
    height:"41px",
    width:"41px",
    fontWeight:"bold",
    paddingTop: "0",
    paddingLeft: "0",
    borderRadius: '50%',
    fontSize: '14px',
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
  },
  tr: {
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'roboto-regular',
    color: '#697683',
    fontSize: 12,
    cursor: 'pointer',
    borderBottom: '1px solid #F5F5F5',
    '& div': {
      textAlign: 'left',
    },
    '@media (max-width: 1025px)': {
      fontSize: 12,
    },
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/dashboard/uncheckbox.svg\")",
  },
  checkedIcon: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 18,
      backgroundImage: "url(\"/assets/icons/dashboard/checkbox.svg\")",
      content: '""',
    },
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  img: {
    width: 120,
    height: 72,
    borderRadius: 10,
    marginRight: 25,
    objectFit: 'cover'
  },
  healthyText: {
    color: '#1DB859',
    fontFamily: 'roboto-regular',
    fontSize: 14,
    '@media (max-width: 1025px)': {
      fontSize: 12,
    },
  },
  m8: {
    margin: '0 8px'
  },
  clips: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '&:hover': {
      cursor: 'pointer'
    },
    '& div': {
      fontFamily: 'roboto-regular',
      fontSoze: 14,
      marginRight: 8
    },
  },
  opened: {
    marginTop: '22px!important',
  },
  muted: {
    color: '#017AEF'
  },
  rotate: {
    transform: 'rotate(90deg)',
  },
  imgDiv: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mp3Icon: {
    width: '38px',
    height: '38px',
    position: 'absolute',
    textAlign: 'center',
    marginLeft: '-33px',
  },
  dotMenu: {
    position: "relative",
    marginLeft: "-30px",
  },
  opacity0: {
    opacity: 0,
  },
  opacity1: {
    opacity: 1,
  },
  uppercase: {
    textTransform: 'uppercase'
  },
  benchmarkIcon: {
    width: 12,
    height: 12,
    marginRight: 5,
    marginLeft: -10
  },
  iconHidden: {
    visibility: 'hidden'
  }
}));

export function CreatorTableBody(props: any) {

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};
  const {
    renameExperiece, onAddRemvoeProject, copyExperience, duplicateExperience, deleteExperiece, selected, disableNavigation,
    onChangeSelected, item, HEADER, userColumn, initialHover, setOpen, open, onSaveBenchmark, onRemoveBenchmark
  } = props;
  const { width } = useWindowSize();

  const goManagerParticipantPage = () => {

    if (disableNavigation)
      return;

    dispatch(initAnalysisData());
    dispatch(initLiveAnalysisData());
    if (!item.session_code) return;
    dispatch(getSessionParticipantsSuccess(null));
    localStorage.setItem("session_code", String(item.session_code));
    localStorage.setItem("session_id", String(item.session_id));
    localStorage.setItem("session_name", String(item.name));

    let routertabname = 'participants';
    switch (item.status.toLowerCase()) {
      case "upcoming":
        routertabname = "participants";
        break;
      case "completed":
        routertabname = "overview";
        break;
      case "live":
        routertabname = "analyze";
        break;
      case "compare":
        routertabname = "compare";
        break;
      default:
        break;
    }
    let url = `/creator/experience-manager/${routertabname}/${item.session_code}`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = `/subscriber/creator/experience-manager/${routertabname}/${item.session_code}`;
    }
    history.push(url, { session_id: item.session_id });
  };

  const onExpandClips = async (item: any) => {
    item.clips.length !== 0 && setOpen(open === item.session_id ? -1 : item.session_id);
    if (item.session_type === 'ASYNC' && item.clips.length !== 0 && open !== item.session_id) {
      const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${item.session_code}`);
      dispatch(getStimulusAnalysis(res.data && res.data[0]));
    }
  };

  const showSafety = useCallback(() => {
    const length = Number(item.session_length);
    return UtilService.isShowSafety(item.session_type, length);
  }, [item]);
  
  return (
    <div className={clsx(classes.tr, classes.m8, item.session_id === open && classes.opened)}>

      <div style={{ width: HEADER[0].width, textAlign:"center" }}>
        {(initialHover === item.session_id || (selected.findIndex((x: any) => x.session_id === item.session_id)) !== -1 || width < 1150) && <Checkbox
          checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
          icon={<span className={classes.icon} />}
          color="primary"
          checked={(selected.findIndex((x: any) => item.session_id === x.session_id)) !== -1}
          onChange={() => onChangeSelected(item)}
          style={{ marginLeft: -8 }}
        />}
      </div>

      <div style={{ width: HEADER[1].width }} className={classes.left} onClick={() => goManagerParticipantPage()}>
        <div className={classes.imgDiv}>
          <img
            src={item.img_large}
            alt={'img'}
            className={classes.img}
            onError={e => e.currentTarget.src = '/assets/images/video-processing.png'}
          />
          {(item.stimulus_type === 'AUDIO') && (
            <img
              src={`/assets/icons/mp3.svg`}
              alt={'img'}
              className={classes.mp3Icon}
              onError={e => e.currentTarget.src = '/assets/images/video-processing.png'}
            />
          )}
        </div>
        {item.saved_benchmark ? (
          <img src={'/assets/icons/dashboard/dashboard-star.svg'} className={classes.benchmarkIcon} />
        ) : (
          <img src={'/assets/icons/dashboard/dashboard-star.svg'} className={clsx(classes.benchmarkIcon, classes.iconHidden)} />
        )}
        {item.name}
      </div>

      <div style={{ width: HEADER[2].width }} className={classes.uppercase} onClick={() => goManagerParticipantPage()}>
        { item.session_code }
      </div>

      <div style={{ width: HEADER[3].width }} onClick={() => goManagerParticipantPage()}>
        {item.session_type === 'ASYNC' ? (
          <img src={'/assets/icons/dashboard/camera_icon.svg'} width='24px' height='24px' />
        ) : (
          <img src={'/assets/icons/dashboard/audio_icon.svg'} width='24px' height='24px' />
        )}
      </div>

      <div style={{ width: HEADER[4].width }} onClick={() => goManagerParticipantPage()}>
        {item.survey_link && <img src={'/assets/icons/dashboard/check_icon.svg'} width='12px' height='12px' />}
      </div>

      <div
        className={classes.clips}
        style={{ width: HEADER[5].width }}
        onClick={() => onExpandClips(item)}
      >
        <div className={clsx(item.clips.length !== 0 && classes.muted)}>
          {item.clips.length !== 0 ? item.clips.length : '-'}
        </div>
        {
          item.clips.length !== 0 &&
          <img
            className={clsx(open === item.session_id && classes.rotate)}
            src={`/assets/icons/dashboard/right.svg`}
            alt="{icon}"
          />
        }
      </div>

      <div
        style={{ width: HEADER[6].width, color: UtilService.refactorGraphColor(item.immersion_color_indicator) }}
        className={classes.healthyText}
        onClick={() => goManagerParticipantPage()}
      >
        {item.immersion ? item.immersion : "-"}
      </div>

      <div
        style={{ width: HEADER[7].width, color: item.safety ? (item.safety > 1 ? UtilService.refactorGraphColor(item.safety_color_indicator) : '#8192A2') : UtilService.refactorGraphColor(item.safety_color_indicator) }}
        className={classes.healthyText}
        onClick={() => goManagerParticipantPage()}
      >
        {(showSafety() && item.safety > 1) ? item.safety : '-'}
      </div>

      <div style={{ width: HEADER[8].width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.formattingString(item.status)}
      </div>

      <div style={{ width: HEADER[9]?.width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.getSimpleDate(item.start)}
      </div>

      <div style={{ width: HEADER[10]?.width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.getSimpleDate(item.end)}
      </div>

      <div style={{ width: HEADER[11]?.width }} onClick={() => goManagerParticipantPage()}>
        {item.participants}
      </div>
      
      {
      (userColumn) ?
        (item.user) ?
          <div style={{ width: HEADER[12]?.width }} onClick={() => goManagerParticipantPage()}>
            <HtmlTooltip disableFocusListener
            style={{backgroundColor:"#000"}}
              title={
                (<div>
                  <strong>First name : </strong> <span>{item.user.first_name}</span> <br />
                  <strong>Last name : </strong> <span>{item.user.last_name}</span> <br />
                  <strong>Email : </strong> <span>{item.user.username}</span> <br />
                </div>)
              }
            >
                {
                  (item.user.first_name && item.user.last_name && item.user.first_name.trim() && item.user.last_name.trim()) ? 
                    <div className={classes.creatorDashboardCircle} style={{backgroundColor:item.userColor,color:"#263238"}}> 
                      {item.user.first_name.trim()[0].toUpperCase() + item.user.last_name.trim()[0].toUpperCase()}
                      {/* <span>{item.user.first_name.trim()[0].toUpperCase() + item.user.last_name.trim()[0].toUpperCase()}</span> */}
                    </div>
                  : 
                    <div className={classes.creatorDashboardCircleUsername} style={{backgroundColor:item.userColor,color:"#263238"}}> 
                      {item.user.username.trim()[0].toUpperCase()}
                      {/* <span>{item.user.username.trim()[0].toUpperCase()}</span> */}
                    </div>
                } 
            </HtmlTooltip>
          </div>
        :
        <div style={{ width: HEADER[12]?.width }} onClick={() => goManagerParticipantPage()}>
          <HtmlTooltip disableFocusListener
          style={{backgroundColor:"#000"}}
          title={
            (<div>
              <strong>First name : </strong> <span>-</span> <br />
              <strong>Last name : </strong> <span>-</span> <br />
              <strong>Email : </strong> <span>-</span> <br />
            </div>)
          }
          >
              {
                <div className={classes.creatorDashboardCircleUsername} style={{backgroundColor:item.userColor,color:"#263238"}}> 
                  - -
                </div>   
              } 
          </HtmlTooltip>
        </div>
      : 
      ""
      }
      
      {/* {!search && */}
        <div className={clsx(classes.dotMenu, classes.opacity0, initialHover === item.session_id && classes.opacity1)}>
          <DotMenuListing
            key={1}
            isreel={false}
            item_session={item}
            onAddRemoveProject={() => onAddRemvoeProject(item)}
            copy_Experience={() => copyExperience(item)}
            duplicate_Experience={() => duplicateExperience(item)}
            delete_Experience={() => deleteExperiece(item)}
            rename_Experiece={() => renameExperiece(item)}
            onSaveBenchmark={() => onSaveBenchmark(item)}
            onRemoveBenchmark={() => onRemoveBenchmark(item)}
          />
        </div>
      {/* } */}
    </div>
  )
}
